import { useFeatureValue } from "@growthbook/growthbook-react";

/**
 * Feature flag okumanın **tek** yolu.
 *
 * `useFeatureIsOn` bilerek kullanılmıyor: bilinmeyen ya da yüklenememiş bir
 * feature için `false` döner. Kill-switch şeklindeki bir flag'de bu, GrowthBook
 * erişilemez olduğu anda özelliğin herkes için kapanması demek — reklam
 * engelleyiciler `cdn.growthbook.io`'yu bloklayabildiği için de teorik bir
 * senaryo değil.
 *
 * `useFeatureValue(key, fallback)` ise fallback'i çağıran belirler. Kural:
 * **fallback her zaman bugünkü davranış olmalı.** Böylece flag'in kaybolması
 * ürünü değiştiremez, yalnızca yeni bir rollout'un ilerlemesini durdurur.
 *
 * @param key GrowthBook feature key'i (kebab-case)
 * @param fallback GrowthBook cevap veremediğinde dönecek değer = bugünkü davranış
 */
export function useFlag(key: string, fallback: boolean): boolean {
  return useFeatureValue<boolean>(key, fallback);
}
